module.exports = __webpack_public_path__ + "img/car_01.c0022a4f.jpg";